module.exports = __webpack_public_path__ + "img/newtweet.10c8d032.png";